/**
 * @file   src\components\Layout.tsx
 * @brief  This component used as a layout for the content which can be replaced.
 * @date   Jun, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { useAppDispatch, useAppSelector } from 'src/hooks';
import { Outlet, useEffect, useNavigate, useParams, React } from '../utils/thirdpartyComponents';
import { getCompanySettings } from 'src/store/actions/settingsAction';
import { resetSettings } from 'src/store/slices/settingsSlice';
import { RootState } from 'src/store';
import { getFromLocalStorage } from 'src/utils/helper';
import { userLogout } from 'src/store/actions/authAction';
import { pageURLs } from 'src/utils/pageUrls';
import { MessageToaster } from 'src/utils/toastUtil';
import axios from '../config/axiosConfig';
import { BayApi } from 'src/utils/apiUrls';


const Layout = () => {
     // Route information variable
     const params = useParams();
     // Declare action dispatch.
     const dispatch = useAppDispatch();
     const navigate = useNavigate();
     // Instantiate MessageToaster
    const toaster = new MessageToaster();
      // Access redux state variables.
      const { getSettings, getSettingsErrorCode } = useAppSelector(
        (state: RootState) => state.settings,
    );
    const { isLogoutSuccess, errorCode, errorMessage } = useAppSelector((state: RootState) => state.auth);

    

// App initial loading 
  useEffect(() => {

    //get theme settings api integration
    if(params.carwashname)
    {
        
        
        const storageData = getFromLocalStorage('CARWASH_DATA');
        const token = storageData ? storageData.accessToken : '';
        const carwashname_on_signin = localStorage.getItem('carwashname');
        if(localStorage.getItem('carwashname') && token !=="" && carwashname_on_signin !== params.carwashname)
        {
          localStorage.removeItem('LOGO_URL_SETTINGS_DATA');
          localStorage.removeItem('carWashID')
          localStorage.removeItem('carWashId');
          localStorage.removeItem('CARWASH_DATA');
          localStorage.removeItem('CARWASH_COMPANY_DATA');
          localStorage.removeItem('carwashname');
          dispatch(userLogout());
          window.location.reload()
        } else if( carwashname_on_signin !== params.carwashname) {
          localStorage.removeItem('LOGO_URL_SETTINGS_DATA');
          localStorage.removeItem('carWashID')
          localStorage.removeItem('carWashId');
          localStorage.removeItem('CARWASH_DATA');
          localStorage.removeItem('CARWASH_COMPANY_DATA');
          const request = { carwashname : params.carwashname }
          fetchAppSettings(request);
        }
        else{
          const request = { carwashname : params.carwashname }
          fetchAppSettings(request);
        }
    }
    return () => {
      dispatch(resetSettings());
    };
  }, [dispatch]);

//   useEffect(() => {
//   getUserActiveWashdetails()
// }, []);

    // Navigate user to login page after sucessfull logout.
    useEffect(() => {
      if (isLogoutSuccess && errorCode === 0) {
        localStorage.removeItem('CARWASH_DATA');
        localStorage.removeItem('CARWASH_COMPANY_DATA');
        localStorage.removeItem('locationPermissionDenied');
        localStorage.removeItem('locationPermissionGranted');
        localStorage.removeItem('LOGO_URL_SETTINGS_DATA');
        navigate("/"+params.carwashname+pageURLs.root);
      } else if (!isLogoutSuccess && errorCode > 0 && errorMessage) {
        toaster.toastError(errorMessage);
      }
    }, [isLogoutSuccess]);

  //apply theme based on company settings
  useEffect(() => {
    document.title=getSettings?.companyName ? getSettings?.companyName : "Car Wash App"
    //console.log("theme settings",getSettings)
    if(getSettings && getSettings?.carWashID > 0)
    {
      localStorage.setItem('carWashId',getSettings?.carWashID)
      if(getSettings?.CarWashURL) {
        localStorage.setItem('carwashname',getSettings?.CarWashURL)
      }
   
    }
    else if(getSettingsErrorCode>0)
    {
      localStorage.removeItem('CARWASH_DATA');
      navigate(pageURLs.error)
    }
    
   }, [getSettings]);

   const fetchAppSettings = async (request : any) => {
    await dispatch(getCompanySettings(request));
   }

    //  const getUserActiveWashdetails = async () => {
    //    try {
    //      // This should be taken from redux or localstorage
     
    //    const { data } = await axios.get(BayApi.GET_ACTIVE_WASH)
    //    if(data?.error === 0){
    //    if(data?.data?.userSubscriptionID){
    //      const userSubscriptionID =data?.data?.userSubscriptionID 
    //      const bayID = data?.data?.bayID 
    //      if(userSubscriptionID>0 &&  bayID>0)
          
    //      navigate(`/${params.carwashname}/${pageURLs.selfService}?activewash=1`,{ state: { UserSubscriptionID: userSubscriptionID ,bayId:bayID }});
    //    }
    //    }
     
    //  } catch (error: any) {
    //    console.log(error.response?.data?.message)
    //  }
    //  }
   
  return (
    <>
      {/* <Header /> */}
      <Outlet />
      {/* <Footer /> */}
    </>
  );
};

export default Layout;
